import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {BaseViewElement} from '../base-view-element';
import {MonitoringLevel} from '../../../core/model/MonitoringLevels.enum';
import {LimitSizeArrayModel} from '../../../core/model/helper-models/limit-size-array.model';
import {DataPoint} from '../../../core/model/helper-models/datapoint.model';
import {PropertySet} from '../../../core/model/helper-models/property-set.model';
import {Property} from '../../../core/model/helper-models/property.model';
import {Thing} from '../../../core/model/thing.model';

@Component({
    selector: 'app-ssagm-statistic-std',
    templateUrl: './ssagm-statistic-std.component.html',
    styleUrls: ['./ssagm-statistic-std.component.scss', './../card.scss'],
    standalone: false
})
export class SsagmStatisticStdComponent extends BaseViewElement implements OnDestroy, OnChanges
{
    @Input() Infeeds: Array<Thing>;
    @Input() Endstellen: Array<Thing>;
    @Input() Allgemein: PropertySet;
    @Input() Wartungseinheit: PropertySet;

    InputHour: Property<any>;
    OutputHour: Property<any>;
    DistanceHour: Property<any>;
    CompressionOn: Property<any>;
    Pressure: Property<any>;

    tmpPressure = [];


    inputHour = new LimitSizeArrayModel<DataPoint<number>>(1000);
    outputHour = new LimitSizeArrayModel<DataPoint<number>>(1000);
    distanceHour = new LimitSizeArrayModel<DataPoint<number>>(1000);


    constructor()
    {
        super('ssagm-statistic-std');
        this.chart = true;
        this.tmpPressure.push(new LimitSizeArrayModel(1));
        this.tmpPressure[0].pushDataPoint(new DataPoint(6, Date.now()));
    }

    ngOnInit()
    {
        super.ngOnInit();
        if (this.Infeeds != null)
        {
            if (this.Infeeds.length > 0)
            {
                for (const infeed of this.Infeeds)
                {
                    infeed.newData.subscribe(() =>
                    {
                        const result = this.countInfeed();
                        if (result.values.length > 0)
                        {
                            const value = this.calcHourlyRate(result);

                            if (value != null)
                            {
                                this.inputHour.pushDataPoint(new DataPoint(value, new Date()));
                            }

                        }
                    });
                }
            }
        }

        if (this.Endstellen != null)
        {
            if (this.Endstellen.length > 0)
            {
                for (const endstelle of this.Endstellen)
                {
                    endstelle.newData.subscribe(() =>
                    {
                        const result = this.countEndstelle();
                        if (result.values.length > 0)
                        {
                            const value = this.calcHourlyRate(result);

                            if (value != null)
                            {
                                this.outputHour.pushDataPoint(new DataPoint(value, new Date()));
                            }

                        }
                    });
                }
            }
        }
    }

    onResize(result: any)
    {
        this.childResizeEvent.emit(result);
    }

    ngOnChanges(changes: SimpleChanges): void
    {
        if (this.Allgemein == null) return;/*
        this.InputHour = this.Allgemein.properties.get('ANZ_EINSCHLEUSUNGEN');
        this.InputHour.TimeseriesData.valuePushed.subscribe(x =>
        {
            const value = this.calcHourlyRate(this.InputHour.TimeseriesData);

            if (value != null)
            {
                this.inputHour.pushDataPoint(new DataPoint(value, x.timestamp));
            }
        });


        this.OutputHour = this.Allgemein.properties.get('ANZ_AUSSCHLEUSUNGEN');
        this.OutputHour.TimeseriesData.valuePushed.subscribe(x =>
        {
            const value = this.calcHourlyRate(this.OutputHour.TimeseriesData);

            if (value != null)
            {
                this.outputHour.pushDataPoint(new DataPoint(value, x.timestamp));
            }
        });
*/

        this.DistanceHour = this.Allgemein.properties.get('STRECKE');
        this.DistanceHour.TimeseriesData.valuePushed.subscribe(x =>
        {
            const value = this.calcHourlyRate(this.DistanceHour.TimeseriesData);

            if (value != null)
            {
                this.distanceHour.pushDataPoint(new DataPoint(value, x.timestamp));
            }
        });


        if (this.Wartungseinheit == null) return;
        this.CompressionOn = this.Wartungseinheit.properties.get('LUFTDRUCK_DRUCK_WERT');
        this.Pressure = this.Wartungseinheit.properties.get('LUFTDRUCK_DRUCK');
    }

    calcHourlyRate(values: LimitSizeArrayModel<DataPoint<any>>)
    {
        if (values == null || values.values.length === 0) return null;

        const timestampNow = new Date(values.currentDatapoint.timestamp).getTime();
        const timestampOneHourAgo = timestampNow - (3600 * 1000);

        const minTime = timestampOneHourAgo - (60 * 1000);
        const maxTime = timestampOneHourAgo + (60 * 1000);

        const possibleValues = values.values.filter(x =>
        {
            const datapointTimestamp = new Date(x.timestamp).getTime();
            if ((datapointTimestamp > minTime) && (datapointTimestamp < maxTime))
            {
                return x;
            }
        });

        if (possibleValues.length === 0) return null;

        return Math.abs(values.currentDatapoint.value - possibleValues[possibleValues.length - 1].value);
    }

    // Sum all Infeed output for calc in hourly rate
    // bad implementation but works
    private countInfeed(): LimitSizeArrayModel<DataPoint<any>>
    {
        const dataArray = new LimitSizeArrayModel<DataPoint<any>>(1000);
        let input = 0;
        let lastTimestamp: Date = new Date();
        if (this.Infeeds != null)
        {
            if (this.Infeeds.length > 0)
            {
                if (this.Infeeds[0].propertySets.get('INFEED') != null)
                {
                    const infeed = this.Infeeds[0].propertySets.get('INFEED');
                    if (infeed.properties.get('ANZ_EINSCHLEUSUNGEN') != null)
                    {
                        const anzeinschleusungen = infeed.properties.get('ANZ_EINSCHLEUSUNGEN');

                        // for every entry in first infeed input values, loop over all infeed values with the same index and add them
                        for (let i = 0; i < anzeinschleusungen.TimeseriesData.values.length; ++i)
                        {
                            lastTimestamp = anzeinschleusungen.TimeseriesData.values[i].timestamp;
                            for (const infeed of this.Infeeds)
                            {
                                if (infeed.propertySets.get('INFEED') == null) continue;
                                if (infeed.propertySets.get('INFEED').properties.get('ANZ_EINSCHLEUSUNGEN') == null) continue;
                                if (infeed.propertySets.get('INFEED').properties.get('ANZ_EINSCHLEUSUNGEN').TimeseriesData.values.length - 1 < i) continue;
                                input += infeed.propertySets.get('INFEED').properties.get('ANZ_EINSCHLEUSUNGEN').TimeseriesData.values[i].value;
                            }

                            dataArray.pushDataPoint(new DataPoint(input, lastTimestamp));
                            input = 0;
                        }

                    }
                }
            }
        }

        return dataArray;
    }

    // Sum all Endstellen output for calc in hourly rate
    // bad implementation but works
    private countEndstelle()
    {
        const dataArray = new LimitSizeArrayModel<DataPoint<any>>(1000);
        let output = 0;
        let lastTimestamp: Date = new Date();
        if (this.Endstellen != null)
        {
            if (this.Endstellen.length > 0)
            {
                if (this.Endstellen[0].propertySets.get('ENDSTELLE') != null)
                {
                    const endstelle = this.Endstellen[0].propertySets.get('ENDSTELLE');
                    if (endstelle.properties.get('ANZ_AUSSCHLEUSUNGEN') != null)
                    {
                        const anzausschleusungen = endstelle.properties.get('ANZ_AUSSCHLEUSUNGEN');

                        // for every entry in first endstelle input values, loop over all endstelle values with the same index and add them
                        for (let i = 0; i < anzausschleusungen.TimeseriesData.values.length; ++i)
                        {
                            lastTimestamp = anzausschleusungen.TimeseriesData.values[i].timestamp;
                            for (const outfeed of this.Endstellen)
                            {
                                if (outfeed.propertySets.get('ENDSTELLE') == null) continue;
                                if (outfeed.propertySets.get('ENDSTELLE').properties.get('ANZ_AUSSCHLEUSUNGEN') == null) continue;
                                if (outfeed.propertySets.get('ENDSTELLE').properties.get('ANZ_AUSSCHLEUSUNGEN').TimeseriesData.values.length - 1 < i) continue;
                                output += outfeed.propertySets.get('ENDSTELLE').properties.get('ANZ_AUSSCHLEUSUNGEN').TimeseriesData.values[i].value;
                            }

                            dataArray.pushDataPoint(new DataPoint(output, lastTimestamp));
                            output = 0;
                        }

                    }
                }
            }
        }

        return dataArray;
    }
}
